import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CreateAdminQuoteNewCustomer } from "@/core";
import { ChangeEvent } from "react";

/** Contact details for a quote whose customer is typed in by hand. */
export function QuoteContactFields({
  contact,
  onChange,
}: Readonly<{
  contact: CreateAdminQuoteNewCustomer;
  onChange: (contact: CreateAdminQuoteNewCustomer) => void;
}>) {
  const field =
    (key: keyof CreateAdminQuoteNewCustomer) =>
    (event: ChangeEvent<HTMLInputElement>) =>
      onChange({ ...contact, [key]: event.target.value });

  return (
    <div className="space-y-4 rounded-md border p-4">
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="space-y-1">
          <Label>First name</Label>
          <Input value={contact.firstName} onChange={field("firstName")} />
        </div>
        <div className="space-y-1">
          <Label>Last name</Label>
          <Input value={contact.lastName} onChange={field("lastName")} />
        </div>
      </div>
      <div className="space-y-1">
        <Label>Email</Label>
        <Input
          type="email"
          value={contact.email}
          onChange={field("email")}
          placeholder="someone@example.com"
        />
      </div>
      <div className="grid grid-cols-[6rem_1fr] gap-4">
        <div className="space-y-1">
          <Label>Code</Label>
          <Input
            value={contact.countryCode}
            onChange={field("countryCode")}
            placeholder="1"
          />
        </div>
        <div className="space-y-1">
          <Label>Phone</Label>
          <Input
            type="tel"
            value={contact.phone}
            onChange={field("phone")}
            placeholder="415 555 2671"
          />
        </div>
      </div>
    </div>
  );
}
